import axios from "axios";

const PATH = "/v2/company-locations";

/**
 * A company location as the v2 API returns it. Unlike the v1 `CompanyLocation`, its `id` is a uuid and its zip is a
 * string, so leading zeros are kept.
 */
export interface CompanyLocationV2Dto {
    id: string;
    name: string;
    street?: string | null;
    zip?: string | null;
    city?: string | null;
    notes?: string | null;
}

/**
 * The body to create or update a company location via the v2 API. `zip` must consist of five digits; an omitted
 * optional field is cleared on update.
 */
export interface CompanyLocationV2Request {
    name: string;
    street?: string | null;
    zip?: string | null;
    city?: string | null;
    notes?: string | null;
}

export default {
    /**
     * Returns all company locations, ordered by name.
     */
    findCompanyLocations (): Promise<CompanyLocationV2Dto[]> {
        return axios.get(PATH)
            .then(response => response.data.companyLocations);
    },
    createCompanyLocation (companyLocation: CompanyLocationV2Request): Promise<CompanyLocationV2Dto> {
        return axios.post(PATH, companyLocation)
            .then(response => response.data);
    },
    updateCompanyLocation (id: string, companyLocation: CompanyLocationV2Request): Promise<CompanyLocationV2Dto> {
        return axios.put(`${PATH}/${id}`, companyLocation)
            .then(response => response.data);
    },
    /**
     * Deletes the company location. Its employees are left without a company location and the customers' travel times
     * from it are deleted with it.
     */
    deleteCompanyLocation (id: string) {
        return axios.delete(`${PATH}/${id}`);
    }
};
